import { useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { appApi } from '../../../../../services/appApi'
import { iConfiguracaoFeedback } from '../components/FormConfiguracaoFeedback'

interface iUseConfiguracaoFeedback {
  Model?: iConfiguracaoFeedback
  setModel: (model: iConfiguracaoFeedback) => void
  IsSaving: boolean
  Salvar: (salvar: boolean) => Promise<boolean>
  Previsualizar: (gestor: boolean) => void
}

export function useConfiguracaoFeedback(feedbackId?: string, ativo = true): iUseConfiguracaoFeedback {
  const toast = useToast()
  const nav = useNavigate()
  const [Model, setModel] = useState<iConfiguracaoFeedback>()
  const [IsSaving, setIsSaving] = useState(false)

  function Obter(): void {
    appApi.get(`Feedback/${feedbackId ?? ''}/Configuracao`)
      .then(res => {
        const data: iConfiguracaoFeedback = res.data
        setModel({ ...data, dataInicio: data.dataInicio?.substring(0, 16) ?? '' })
      })
      .catch(err => console.log(err))
  }

  async function Salvar(salvar: boolean): Promise<boolean> {
    if (Model === undefined || IsSaving) return false
    setIsSaving(true)
    return await appApi.put(`Feedback/${feedbackId ?? ''}/Configuracao?salvar=${salvar ? 'true' : 'false'}`, Model)
      .then(() => {
        toast({
          title: 'Configuração do feedback atualizada com sucesso!',
          status: 'success',
          isClosable: false,
          position: 'top-right',
          duration: 4000
        })
        return true
      })
      .catch(err => {
        console.log(err)
        setIsSaving(false)
        return false
      })
  }

  function Previsualizar(gestor: boolean): void {
    if (Model === undefined) return
    appApi.put(`Feedback/${feedbackId ?? ''}/Configuracao?salvar=true`, Model)
      .then(() => {
        nav(`/Feedback/Abertura/${feedbackId ?? ''}/Previsualizar`,
          {
            state: {
              gestor: gestor
            }
          })
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    if (ativo && feedbackId !== undefined) {
      setModel(undefined)
      setIsSaving(false)
      Obter()
    }
  }, [feedbackId, ativo])

  return { Model, setModel, IsSaving, Salvar, Previsualizar }
}
